export const API_V1 = '/api/v1';
export const API_V2 = '/api/v2';
